import { gql } from 'apollo-angular';

export const USER_VALIDATION_QUERY = gql`
  query IsUserExists($email: String!, $accountDnvId: String) {
    isUserExists(email: $email, accountDnvId: $accountDnvId) {
      data {
        email
        isUserExist
      }
      errorCode
      isSuccess
      message
    }
  }
`;
